export default function getApiErrorMessage (error) {
  const data = error?.response?.data
  const errorMessages = data?.errorMessages

  if (errorMessages?.length) return errorMessages.join(' ')

  return data?.message || ''
}

export function withApiErrorDetail (error, message) {
  const detail = getApiErrorMessage(error)
  return detail ? `${message}: ${detail}` : message
}
